import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-49" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-50" data-mp="c6ivdvtic587">
        <h2 className="font-display text-[1.25rem] font-bold uppercase leading-tight text-white sm:text-[1.8rem]" data-id="element-51" data-mp="c7k8e5u331sk">
          ONE LAST QUESTION
        </h2>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-52" data-mp="m4ow4a3kv5bh">
          When several clamps, forceps, scissors, retractors or needle holders are placed in front of
          you...
        </p>
        <p className="mt-1 font-display text-[1rem] font-bold leading-tight text-gold sm:text-[1.2rem]" data-id="element-53" data-mp="vv1crr89uecc">
          Can you confidently recognize what makes each one different?
        </p>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-54" data-mp="14uwtscoid3ka">
          Stop jumping between scattered references and trying to memorize instrument names without
          understanding what you're actually seeing.
        </p>
        <p className="mt-1 font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.88rem]" data-id="element-55" data-mp="2c6r9g3ymy6m0">
          Observe the instrument. Identify the family. Compare the features. Recognize the difference.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[240px] sm:max-w-[300px]" data-id="element-56" data-mp="2r2go1h1hrhgp" />

        <p className="mt-2 font-display text-[1.1rem] font-bold uppercase text-white sm:text-[1.5rem]" data-id="element-57" data-mp="2v3iou2b241ks">
          🔬 SURGICAL INSTRUMENTS <span className="text-gold" data-id="element-58" data-mp="301tyod1cqc30">VISUAL ATLAS™</span>
        </p>
        <p className="mt-0.5 font-heading text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.8rem]" data-id="element-59" data-mp="34tc0127aeeoi">
          THE COMPLETE VISUAL STUDY SYSTEM FOR SURGICAL INSTRUMENTS
        </p>
        <p className="mt-0.5 font-heading text-[0.62rem] font-bold uppercase tracking-[0.12em] text-clinical sm:text-[0.76rem]" data-id="element-60" data-mp="3eri2pm0x3ouf">
          Observe • Identify • Compare • Differentiate • Recognize
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-61" data-mp="1jo3hri2jm741">
          <p className="font-heading text-[0.78rem] font-black uppercase tracking-wide text-white sm:text-[0.92rem]" data-id="element-62" data-mp="1jov19uiv8edy">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-63" data-mp="1showj1epjodg">
            <CTAButton label="⚡ GET SURGICAL INSTRUMENTS VISUAL ATLAS™" data-id="element-64" data-mp="1sirnf9c15qtd" />
          </div>
          <p className="mt-2 font-heading text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-65" data-mp="1nonfamr13cqp">
            Immediate Access • Digital Delivery
          </p>
          <p className="mt-0.5 font-heading text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-66" data-mp="1xeyiu86svjx2">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}